(() => {
  const order = ["destinos", "planes", "resumen", "pago", "exito"];

  const detectStepFromURL = () => {
    const path = window.location.pathname.toLowerCase();
    if (path === "/cart" || path.startsWith("/cart/")) return "resumen";
    if (path.includes("/checkout")) return "pago";
    if (path.startsWith("/pages/destinos")) return "destinos";
    if (path.startsWith("/pages/planes") || path.includes("/products/")) return "planes";
    return null;
  };

  const initBar = (root) => {
    // Prioridad 1: Configuración del admin de Shopify (data-current-step)
    // Prioridad 2: Detección automática por URL
    // Prioridad 3: Fallback a "planes"
    const shopifySetting = root.dataset.currentStep || "";
    const autoStep = detectStepFromURL();
    
    const current = (shopifySetting || autoStep || "planes").toLowerCase();

    const steps = Array.from(root.querySelectorAll('.purchase-bar__step'));
    const idx = order.indexOf(current);

    steps.forEach((step, i) => {
      // Limpiamos clases previas
      step.classList.remove('is-pending', 'is-active', 'is-completed', 'has-line-completed');
      
      // Aplicamos estados
      if (i < idx) {
        step.classList.add('is-completed');
      } else if (i === idx) {
        step.classList.add('is-active');
      } else {
        step.classList.add('is-pending');
      }

      // Pintamos la línea conectora si el paso anterior está completo o es el activo
      const line = step.querySelector('.purchase-bar__line');
      if (line) {
        if (i <= idx) step.classList.add('has-line-completed');
      }
    });

    const back = root.querySelector('.purchase-bar__back');
    if (!back) return;

    if (current === 'exito' || idx <= 0) {
      back.setAttribute('aria-disabled', 'true');
      back.style.pointerEvents = 'none';
      back.style.opacity = '0.6';
      back.removeAttribute('href');
    } else {
      back.setAttribute('href', '#');
      back.removeAttribute('aria-disabled');
      back.style.pointerEvents = '';
      back.style.opacity = '';
      
      back.onclick = (e) => {
        e.preventDefault();
        window.history.back();
      };
    }
  };

  const initAll = () => {
    document.querySelectorAll('.purchase-bar').forEach(initBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();